import { render, staticRenderFns } from "./Add2.vue?vue&type=template&id=a2bf4d54&scoped=true"
import script from "./Add2.vue?vue&type=script&lang=js"
export * from "./Add2.vue?vue&type=script&lang=js"
import style0 from "./Add2.vue?vue&type=style&index=0&id=a2bf4d54&prod&lang=less"
import style1 from "./Add2.vue?vue&type=style&index=1&id=a2bf4d54&prod&lang=less&scoped=true"
import style2 from "./Add2.vue?vue&type=style&index=2&id=a2bf4d54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf4d54",
  null
  
)

export default component.exports